import React, { useEffect, useState } from "react";
import { getDomainConfig } from "../../config/config";

const StandardValidation = (props) => {

const config = getDomainConfig();

/* LOADING THE BRANDED SCSS */
const [styles, setStyles] = useState(false);

useEffect(() => {

const getStyles = async (theFileName, theFileEnd) => {
  if (config.brand) {
    let moduleStyles = false;
    try {
      moduleStyles = await import(
        "./" + theFileName + config.brand + theFileEnd
      );
      setStyles(moduleStyles);
    } catch (e) {
      console.error(
        `Styles for ${theFileName} could not be loaded, ${e.message}`
      );
    }
  }
};

  // Specify file name and end of file name here.
  getStyles("StandardValidation", ".module.scss");
}, [config.brand]);

/* END LOADING THE BRANDED SCSS */


  const propsId = props.id; // The id that may have come through from props
  let defaultClass = styles.validation; // The generic class (in css modules format)
  let classes = defaultClass; // The classes list to show
  let icon = "";

  if (props.className) {
    // If any extra classes come through via props, turn them into css modules format too
    classes =
      classes +
      " " +
      props.className
        .split(" ")
        .map((thisStyle) => {
          return styles[thisStyle];
        })
        .join(" ");
  }

  if (props.icon) {
    icon = <span className={styles.icon}></span>;
    if (props.valType === "success") {
      icon = <span className={styles.successIcon}></span>;
    }
    if (props.valType === "error") {
      icon = <span className={styles.errorIcon}></span>;
    }
  }

  let spanClass = styles.text;
  if (props.valType === "success") {
    spanClass = styles.successText;
  }
  if (props.valType === "error") {
    spanClass = styles.errorText;
  }

  // create dynamic test id so field can be targeted by Cypress
  const dataTestId = `${props.id}-${props.valType}`

  return (
    <p data-cy={dataTestId} className={classes} id={propsId}>
      {icon}
      <span className={spanClass}>{props.children}</span>
    </p>
  );
};

export default StandardValidation;
